import { withPermissions } from "@components/withPermissions";
import { BpIdUsersSearchArgs } from "@libs/api/gateways/bp-id/bp-id.dtos";
import { IdentityFilter } from "modules/users/components/IdentityFilter";
import { ConsumerUserIdentitiesTable } from "modules/users/ConsumerUser/ConsumerUserIdentitiesTable";
import React, { useState } from "react";

import {
  MessageBar,
  MessageBarType,
  NoDataTile,
  Stack,
  useTheme
} from "@bps/fluent-ui";
import { Permissions } from "@libs/permissions/permissions.enum";
import { useCUIdentitySearch } from "@libs/api/gateways/best-health/account/best-health-account-ops-gateway.hooks";

const ConsumerUserIdentitiesBase: React.FC = () => {
  const theme = useTheme();
  const [filter, setFilter] = useState<BpIdUsersSearchArgs>();
  const { data, isFetching } = useCUIdentitySearch(filter);

  return (
    <Stack verticalFill tokens={{ childrenGap: theme.spacing.m }}>
      <IdentityFilter onFilter={setFilter} />
      {data?.tooManyResults === true && (
        <MessageBar messageBarType={MessageBarType.error}>
          Your search returned too many results, please refine your search
          parameters.
        </MessageBar>
      )}
      <Stack verticalFill>
        {data?.records?.length || isFetching ? (
          <ConsumerUserIdentitiesTable
            enableShimmer={isFetching}
            items={data?.records || []}
          />
        ) : (
          <NoDataTile
            textProps={{ text: "No Consumer Users found" }}
            linkProps={{ hidden: true }}
            showBoxShadow={false}
          />
        )}
      </Stack>
    </Stack>
  );
};

export const ConsumerUserIdentities = withPermissions(
  ConsumerUserIdentitiesBase,
  [Permissions.PltCatalogUserRead, Permissions.PltCatalogUserWrite],
  "or"
);
